export const ADMIN_CAD_USERS_SCREEN = '/users';
